"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6746],{

/***/ 76746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ containers_WhyCarPlannerContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/icons/index.tsx + 28 modules
var icons = __webpack_require__(27120);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/containers/data/WhyCarplannerData.tsx


var WhyCarPlannerData = [{
  title: 'Cerca l’auto perfetta\nper le tue esigenze!',
  description: 'Selezioniamo per te le migliori offerte sul mercato per il Noleggio a Lungo Termine e l’Acquisto!',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenCarIcon */.$C, {})
}, {
  title: 'Acquista o Noleggia\n online in pochi passi',
  description: 'Ti guidiamo nella scelta della tua nuova auto con un servizio semplice, veloce e trasparente, ottimizzando i tempi!',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenClickIcon */.sZ, {})
}, {
  title: 'Consulenti esperti sempre\n a tua disposizione',
  description: 'Il cliente sempre al centro: puoi contare sulla nostra esperienza per rispondere a tutte le tue domande e consigliarti al meglio! ',
  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* GreenSupportIcon */.Tq, {})
}];
/* harmony default export */ var WhyCarplannerData = (WhyCarPlannerData);
;// CONCATENATED MODULE: ./src/containers/WhyCarPlannerContainer.tsx





var WhyCarPlannerList = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(5061), __webpack_require__.e(7855), __webpack_require__.e(1189)]).then(__webpack_require__.bind(__webpack_require__, 55797));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(55797)];
    }
  }
});

var WhyCarPlannerContainer = function WhyCarPlannerContainer(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhyCarPlannerList, {
      title: title,
      items: WhyCarplannerData
    })
  });
};

/* harmony default export */ var containers_WhyCarPlannerContainer = (WhyCarPlannerContainer);

/***/ })

}]);